import { apiClient } from './apiClient';

export interface RequestOtpData {
  message: string;
  email: string;
  expiresInSeconds: number;
}

export interface VerifyOtpData {
  message: string;
  isValid: boolean;
}

export interface ResetPasswordData {
  message: string;
  success: boolean;
}

interface ApiResponse<T> {
  result: 'success' | 'error';
  message: string;
  data: T;
}

const passwordResetService = {
  /**
   * Request OTP - Gửi mã OTP đến email
   */
  async requestOtp(email: string): Promise<RequestOtpData> {
    const response = await apiClient.post<ApiResponse<RequestOtpData>>(
      '/api/auth/password-reset/request',
      { email: email.trim().toLowerCase() }
    );
    return response.data;
  },

  /**
   * Verify OTP - Xác thực mã OTP (optional step)
   */
  async verifyOtp(email: string, otpCode: string): Promise<VerifyOtpData> {
    const response = await apiClient.post<ApiResponse<VerifyOtpData>>(
      '/api/auth/password-reset/verify-otp',
      {
        email: email.trim().toLowerCase(),
        otpCode: otpCode.trim()
      }
    );
    return response.data;
  },

  /**
   * Reset Password - Đặt lại mật khẩu với OTP
   */
  async resetPassword(
    email: string,
    otpCode: string,
    newPassword: string
  ): Promise<ResetPasswordData> {
    const response = await apiClient.post<ApiResponse<ResetPasswordData>>(
      '/api/auth/password-reset/reset',
      {
        email: email.trim().toLowerCase(),
        otpCode: otpCode.trim(),
        newPassword
      }
    );
    return response.data;
  }
};

export default passwordResetService;
